import * as React from "react"
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa"
import {
  SettingsBodyTitle,
  ControlButton,
  SettingsBodyText,
  InputWrapper,
  Input
} from "./settings.styled"
import { SettingMicrophoneProps } from "./settings.interfaces"
import Dropdown from "../common/dropdown"
import { Icon } from "../common/icons"
import { useResizeObserver } from "../../hooks/useResizeObserver"
import useWindowSize from "../../hooks/useWindowSize"
import { useTranslation } from "react-i18next"
import DeniedPermissionWarning from "./DeniedPermissionWarning"
import { Flex } from "@chakra-ui/layout"

const _SettingMicrophone: React.FC<SettingMicrophoneProps> = ({
  currentMutedDevices,
  isShowFullView,
  roomStyles,
  handleChangeMuteDevice,
  handleChangeDevice,
  devicesLists,
  currentAudio,
  audioTrack,
  isHomePage,
  сolorBorder,
  devicePermissionDenied
}) => {
  const { t } = useTranslation()
  // const _stylingDisabledIcon: React.CSSProperties = React.useMemo(() => {
  //   return audioTrack ? null : { opacity: 0.5 }
  // }, [audioTrack])

  // const disabledButton = React.useMemo(
  //   () => (audioTrack ? false : true),
  //   [audioTrack]
  // )

  const changeMuteDevice = React.useCallback(() => {
    handleChangeMuteDevice("audio", !currentMutedDevices.audio)
  }, [currentMutedDevices.audio, handleChangeMuteDevice])

  const Icons = React.useMemo(() => {
    return currentMutedDevices.audio ? (
      <Icon
        color={roomStyles?.joinPageButtonTextColor}
        src={FaMicrophoneSlash}
      />
    ) : (
      <Icon color={roomStyles?.joinPageButtonTextColor} src={FaMicrophone} />
    )
  }, [currentMutedDevices.audio])

  const stylesInput = React.useMemo(() => {
    return !isHomePage
      ? {
          border: `2px solid ${сolorBorder}`,
          backgroundColor: roomStyles?.servicePanelElementBackground,
          color: roomStyles?.servicePanelElementPrimaryText,
          borderLeft: "none"
        }
      : {}
  }, [
    isHomePage,
    roomStyles?.servicePanelElementBackground,
    roomStyles?.servicePanelElementPrimaryText,
    сolorBorder
  ])

  const handleOnChange = React.useCallback(
    item => {
      handleChangeDevice("audio", item)
    },
    [handleChangeDevice]
  )

  const inputWrapper = React.useRef<HTMLDivElement>(null)
  const [widthInputWrapper] = useResizeObserver(inputWrapper)

  const { screenSize } = useWindowSize()
  const isSmallWindowHeight = React.useMemo(
    () => 570 > screenSize.height || screenSize.width < 1024,
    [screenSize.height, screenSize.width]
  )

  return (
    <>
      <SettingsBodyTitle
        isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
        roomStyles={roomStyles}
        isHomePage={isHomePage}
      >
        {!isShowFullView && (
          <Flex marginRight="15px">
            <DeniedPermissionWarning
              isDenied={devicePermissionDenied?.audio}
              top="-14px"
              right="0px"
            >
              <ControlButton
                roomStyles={roomStyles}
                type="button"
                onClick={changeMuteDevice}
                // disabled={disabledButton}
                // style={_stylingDisabledIcon}
              >
                {Icons}
              </ControlButton>
            </DeniedPermissionWarning>
          </Flex>
        )}
        {t("Microphone")}
      </SettingsBodyTitle>
      <SettingsBodyText
        isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
        roomStyles={roomStyles}
        isHomePage={isHomePage}
      >
        {t("Please speak to confirm your mic works")}
      </SettingsBodyText>
      <InputWrapper
        isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
        ref={inputWrapper}
      >
        <Dropdown
          label={t("Mics")}
          onChange={handleOnChange}
          list={devicesLists.audio}
          сolorBorder={сolorBorder}
          emptyText={t("Empty devices")}
          roomStyles={!isHomePage && roomStyles}
          customstyles={{
            item: {
              width: `${widthInputWrapper - 4}px`
            },
            list: {
              top: "unset",
              bottom: "100%",
              display: "flex",
              flexDirection: "column"
            },
            button: {
              padding:
                isSmallWindowHeight && isShowFullView && "0.3rem 0.75rem",
              fontSize: isSmallWindowHeight && isShowFullView && "0.9rem"
            }
          }}
        />
        <Input
          style={stylesInput}
          isSmallWindowHeight={isSmallWindowHeight && isShowFullView}
          type="text"
          disabled
          value={currentAudio?.label || t("No microphone")}
        />
      </InputWrapper>
    </>
  )
}

export const SettingMicrophone = React.memo(_SettingMicrophone)
